module.exports = __webpack_public_path__ + "static/media/fvs_salaMendoza_11.37a25239.jpg";